/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">SW-1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">SW-2</vs-button>
          <vs-button :color="sel==='sw3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw3'">SW-3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">VLAN 99 named FINANCIAL on all switches</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/6</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2','sw3']" :key="'t1-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task1Items" :key="'t1-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Configure e0/2 access ports to PCs</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/9</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2Sw1Items" :key="'t2-sw1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2Sw2Items" :key="'t2-sw2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-3</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2Sw3Items" :key="'t2-sw3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw3Completion[item.key])"></div>
                  <code class="text-base" :class="sw3Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">Re-enable CDP on SW-1</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/1</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-1</span>
              <div class="space-y-1 ml-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion.cdpRun)"></div>
                  <code class="text-base" :class="sw1Completion.cdpRun?'text-success':''">cdp run</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: run <code>show cdp neighbors</code> on SW-2</p>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">Disable CDP on SW-1 e0/2 (PC1 port)</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW-1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw1Completion.saved,sw2Completion.saved,sw3Completion.saved].filter(Boolean).length }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2','sw3']" :key="'s-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk).saved)"></div>
                    <code class="text-base" :class="getComp(swk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-2" />
          <vue-command v-show="sel==='sw3'" key="sw3" id="sw3_terminal" :commands="sw3Commands" :prompt="sw3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-3" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "show vlan" or "show cdp neighbors" to verify state.';

const mkCommands = (swk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(swk),
  configure:  (x) => vm.iosConfigure(swk, x),
  conf:       (x) => vm.iosConfigure(swk, x),
  vlan:       (x) => vm.iosVlan(swk, x),
  name:       (x) => vm.iosName(swk, x),
  interface:  (x) => vm.iosInterface(swk, x),
  int:        (x) => vm.iosInterface(swk, x),
  switchport: (x) => vm.iosSwitchport(swk, x),
  no:         (x) => vm.iosNo(swk, x),
  cdp:        (x) => vm.iosCdp(swk, x),
  show:       (x) => vm.iosShow(swk, x),
  exit:       () => vm.iosExit(swk),
  end:        () => vm.iosEnd(swk),
  copy:       (x) => vm.iosCopy(swk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/VLAN_CDP.png',
      sel: 'sw1',
      totalScore: 0,

      sw1: { mode: 'exec', currentVlan: null, currentIf: null },
      sw2: { mode: 'exec', currentVlan: null, currentIf: null },
      sw3: { mode: 'exec', currentVlan: null, currentIf: null },

      // sw1: task1(2) + task2(3) + task3(1) + task4(1 new) + saved(1) = 8
      sw1Completion: {
        vlan99: false, vlan99Name: false,
        e02If: false, e02Access: false, e02Vlan: false,
        cdpRun: false,
        e02NoCdp: false,
        e02IfT4: false, // display-only: Task 4 re-entry of "interface e0/2" (not scored; e02If is the scored Task 2 entry)
        saved: false,
      },
      // sw2: task1(2) + task2(3) + saved(1) = 6
      sw2Completion: {
        vlan99: false, vlan99Name: false,
        e02If: false, e02Access: false, e02Vlan: false,
        saved: false,
      },
      // sw3: task1(2) + task2(3) + saved(1) = 6
      sw3Completion: {
        vlan99: false, vlan99Name: false,
        e02If: false, e02Access: false, e02Vlan: false,
        saved: false,
      },

      sw1Commands: null,
      sw2Commands: null,
      sw3Commands: null,

      task1Items: [
        { key: 'vlan99',     label: 'vlan 99' },
        { key: 'vlan99Name', label: 'name FINANCIAL' },
      ],
      task2Sw1Items: [
        { key: 'e02If',    label: 'interface e0/2' },
        { key: 'e02Access', label: 'switchport mode access' },
        { key: 'e02Vlan',  label: 'switchport access vlan 99' },
      ],
      task2Sw2Items: [
        { key: 'e02If',    label: 'interface e0/2' },
        { key: 'e02Access', label: 'switchport mode access' },
        { key: 'e02Vlan',  label: 'switchport access vlan 1' },
      ],
      task2Sw3Items: [
        { key: 'e02If',    label: 'interface e0/2' },
        { key: 'e02Access', label: 'switchport mode access' },
        { key: 'e02Vlan',  label: 'switchport access vlan 99' },
      ],
      task4Items: [
        { key: 'e02IfT4',  label: 'interface e0/2' },
        { key: 'e02NoCdp', label: 'no cdp enable' },
      ],
    };
  },

  computed: {
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config-vlan') return 'SW-1(config-vlan)#';
      if (m === 'config-if')   return 'SW-1(config-if)#';
      if (m === 'config')      return 'SW-1(config)#';
      return 'SW-1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config-vlan') return 'SW-2(config-vlan)#';
      if (m === 'config-if')   return 'SW-2(config-if)#';
      if (m === 'config')      return 'SW-2(config)#';
      return 'SW-2#';
    },
    sw3Prompt() {
      const m = this.sw3.mode;
      if (m === 'config-vlan') return 'SW-3(config-vlan)#';
      if (m === 'config-if')   return 'SW-3(config-if)#';
      if (m === 'config')      return 'SW-3(config)#';
      return 'SW-3#';
    },

    task1Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion, c3 = this.sw3Completion;
      return [c1.vlan99, c1.vlan99Name, c2.vlan99, c2.vlan99Name, c3.vlan99, c3.vlan99Name].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 6; },

    task2Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion, c3 = this.sw3Completion;
      return [c1.e02If, c1.e02Access, c1.e02Vlan,
              c2.e02If, c2.e02Access, c2.e02Vlan,
              c3.e02If, c3.e02Access, c3.e02Vlan].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 9; },

    task3Progress() { return this.sw1Completion.cdpRun ? 1 : 0; },
    task3Done()     { return !!this.sw1Completion.cdpRun; },

    task4Progress() {
      const c1 = this.sw1Completion;
      return [c1.e02IfT4, c1.e02NoCdp].filter(Boolean).length;
    },
    task4Done() { return !!this.sw1Completion.e02NoCdp; },

    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved && this.sw3Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.sw1Commands = mkCommands('sw1', this);
    this.sw2Commands = mkCommands('sw2', this);
    this.sw3Commands = mkCommands('sw3', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    swkLabel(k) { return k === 'sw1' ? 'SW-1' : k === 'sw2' ? 'SW-2' : 'SW-3'; },

    dot(val) {
      return { width: '8px', height: '8px', background: val ? '#28C76F' : 'transparent', border: '2px solid ' + (val ? '#28C76F' : '#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^fa/, '')
        .replace(/^e(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      // e02IfT4 is a display-only flag for the Task 4 re-entry of "interface e0/2" — not scored.
      [this.sw1Completion, this.sw2Completion, this.sw3Completion].forEach(c =>
        Object.entries(c).forEach(([k, v]) => { if (v && k !== 'e02IfT4') score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      // sw1(8) + sw2(6) + sw3(6) = 20
      if (score >= 20) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(swk) {
      this[swk].mode = 'exec';
      return createStdout('');
    },

    iosConfigure(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(swk) {
      const s = this[swk];
      if (s.mode === 'config-if' || s.mode === 'config-vlan') {
        s.mode = 'config';
        s.currentVlan = null;
        s.currentIf = null;
      } else if (s.mode === 'config') {
        s.mode = 'exec';
      }
      return createStdout('');
    },

    iosEnd(swk) {
      this[swk].mode = 'exec';
      this[swk].currentVlan = null;
      this[swk].currentIf = null;
      return createStdout('');
    },

    iosVlan(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config' && s.mode !== 'config-vlan') {
        return createStderr('% Invalid input detected — must be in global or VLAN configuration mode');
      }
      const vlanId = String(x._[1] || '');
      if (!vlanId || isNaN(vlanId)) return createStderr('% Invalid input detected');

      s.mode = 'config-vlan';
      s.currentVlan = vlanId;
      s.currentIf = null;

      const c = this[swk + 'Completion'];
      if (vlanId === '99' && !c.vlan99) { c.vlan99 = true; this.updateScore(); }

      return createStdout('');
    },

    iosName(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-vlan') return createStderr('% Invalid input detected — must be in VLAN configuration mode');
      const nameRaw = (x._[1] || '');
      if (!nameRaw) return createStderr('% Invalid input detected');
      const nameUp = nameRaw.toUpperCase();
      const c = this[swk + 'Completion'];

      if (s.currentVlan === '99' && nameUp === 'FINANCIAL' && !c.vlan99Name) {
        c.vlan99Name = true; this.updateScore();
        const swName = this.swkLabel(swk);
        const remaining = ['sw1','sw2','sw3'].filter(k => !this[k + 'Completion'].vlan99Name);
        const next = remaining.length
          ? `→ Configure VLAN 99 on ${remaining.map(k => this.swkLabel(k)).join(' and ')}.`
          : '→ All three switches have VLAN 99. Configure Task 2: access ports to PCs.';
        return createStdout(this.guide(
          `VLAN 99 named FINANCIAL on ${swName}. The VLAN must be created with the correct name on every switch that will carry its traffic — frames tagged as VLAN 99 are only forwarded if the VLAN exists in the local VLAN database. ${next}`
        ));
      }

      return createStdout('');
    },

    iosInterface(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      let ifArg = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      let ifNorm = this.normalizeIf(ifArg);

      // E0/0 → fa0/10 in Packet Tracer; accept fa0/10 as alias for e0/0
      if (ifNorm === '0/10') ifNorm = '0/0';

      s.mode = 'config-if';
      s.currentIf = ifNorm;
      s.currentVlan = null;

      const c = this[swk + 'Completion'];
      if (ifNorm === '0/2' && !c.e02If) { c.e02If = true; this.updateScore(); }
      // SW-1 re-entry of e0/2 for Task 4 (after "cdp run" in Task 3) — mark the Task 4 step
      // only now, not back in Task 2 when e0/2 was first configured.
      else if (ifNorm === '0/2' && swk === 'sw1' && c.cdpRun && 'e02IfT4' in c && !c.e02IfT4) { c.e02IfT4 = true; this.updateScore(); }

      return createStdout('');
    },

    iosSwitchport(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const c = this[swk + 'Completion'];
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const ifn = s.currentIf;

      // switchport mode access
      if (sub1 === 'mode' && sub2 === 'access') {
        if (ifn === '0/2' && !c.e02Access) {
          c.e02Access = true; this.updateScore();
          const swName = this.swkLabel(swk);
          return createStdout(this.guide(
            `${swName} e0/2 set to access mode. Access mode places the port into a single VLAN and strips 802.1Q tags — the connected PC sends and receives untagged frames. ` +
            (swk === 'sw2' ? '→ "switchport access vlan 1" to explicitly assign the default VLAN (optional but educational).' : '→ "switchport access vlan 99" to assign the FINANCIAL VLAN.')
          ));
        }
        return createStdout('');
      }

      // switchport access vlan <id>
      if (sub1 === 'access' && sub2 === 'vlan') {
        const vlanId = String(x._[3] || '');
        if (ifn === '0/2' && !c.e02Vlan) {
          if ((swk === 'sw1' || swk === 'sw3') && vlanId === '99') {
            c.e02Vlan = true; this.updateScore();
            const swName = this.swkLabel(swk);
            const other = swk === 'sw1' ? 'SW-3' : 'SW-1';
            const otherDone = swk === 'sw1' ? this.sw3Completion.e02Vlan : this.sw1Completion.e02Vlan;
            return createStdout(this.guide(
              `${swName} e0/2 assigned to VLAN 99 (FINANCIAL). PC1 (or PC3) is now in the FINANCIAL broadcast domain. ` +
              (otherDone ? '→ Configure SW-2 e0/2 for the DEFAULT VLAN.' : `→ Configure ${other} e0/2 the same way, then SW-2.`)
            ));
          }
          if (swk === 'sw2' && vlanId === '1') {
            c.e02Vlan = true; this.updateScore();
            return createStdout(this.guide(
              'SW-2 e0/2 explicitly assigned to VLAN 1 (default). ' +
              'This command is technically not required — all access ports are in VLAN 1 by default. ' +
              'Typing it explicitly is useful to document intent and verify the VLAN is correct after a "show vlan" check. ' +
              '→ Configure Task 3: re-enable CDP on SW-1 with "cdp run".'
            ));
          }
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosNo(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const c = this[swk + 'Completion'];

      if (sub1 === 'cdp' && sub2 === 'enable') {
        if (swk === 'sw1' && s.currentIf === '0/2' && !c.e02NoCdp) {
          c.e02NoCdp = true; this.updateScore();
          return createStdout(this.guide(
            'CDP disabled on SW-1 e0/2 (the PC1 port). PC1 can no longer receive CDP frames from SW-1, so it cannot discover the switch via Cisco\'s neighbor protocol. ' +
            'Global CDP on SW-1 remains active — SW-2 and SW-3 still see SW-1 as a CDP neighbor on the uplink. ' +
            '→ Save all three switches: "end" then "copy running-config startup-config".'
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosCdp(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      const sub1 = (x._[1] || '').toLowerCase();
      const c = this[swk + 'Completion'];

      if (sub1 === 'run' && swk === 'sw1' && !c.cdpRun) {
        c.cdpRun = true; this.updateScore();
        return createStdout(this.guide(
          'CDP re-enabled globally on SW-1. SW-1 will now send CDP advertisements on all interfaces (except those with "no cdp enable"). ' +
          '→ Verify: switch to SW-2 and run "show cdp neighbors" — SW-1 should now appear as a neighbor. ' +
          '→ Then configure Task 4: disable CDP on SW-1 e0/2 so PC1 cannot discover the switch.'
        ));
      }

      return createStdout('');
    },

    iosShow(swk, x) {
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();

      if (sub1 === 'vlan') {
        const c = this[swk + 'Completion'];
        const rows = ['1    default                          active    E0/2, E0/3'];
        if (c.vlan99 && c.vlan99Name) rows.push('99   FINANCIAL                        active');
        else if (c.vlan99)            rows.push('99   VLAN0099                          active');
        rows.push('1002 fddi-default                     act/unsup');
        rows.push('1003 token-ring-default               act/unsup');
        rows.push('1004 fddinet-default                  act/unsup');
        rows.push('1005 trnet-default                    act/unsup');
        return createStdout(
          'VLAN Name                             Status    Ports<br>' +
          '---- -------------------------------- --------- -------------------------------<br>' +
          rows.join('<br>')
        );
      }

      if (sub1 === 'cdp' && sub2 === 'neighbors') {
        const header =
          'Capability Codes: R - Router, T - Trans Bridge, B - Source Route Bridge<br>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;S - Switch, H - Host, I - IGMP, r - Repeater, P - Phone<br>' +
          'Device ID&nbsp;&nbsp;&nbsp;&nbsp;Local Intrfce&nbsp;&nbsp;&nbsp;Holdtme&nbsp;&nbsp;&nbsp;Capability&nbsp;&nbsp;Platform&nbsp;&nbsp;&nbsp;Port ID<br>';
        let rows = '';
        if (swk === 'sw2') {
          if (this.sw1Completion.cdpRun) {
            rows += 'Sw-1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fas 0/10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;125&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3560&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fas 0/10<br>';
          }
          rows += 'Sw-3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fas 0/1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;125&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3560&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fas 0/1<br>';
          if (!this.sw1Completion.cdpRun) {
            rows += this.guide('SW-1 not visible — CDP is disabled on SW-1. Complete Task 3: type "cdp run" on SW-1 first.');
          }
        }
        return createStdout(header + rows);
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[swk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(
            `${this.swkLabel(swk)} configuration saved to NVRAM. ` +
            (this.saveDone ? '✓ All switches saved — simulation complete!' : '→ Save the remaining switches.')
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal, #sw3_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

